import * as http from './base-api'
import * as querystring  from 'querystring'


/**
 * 회원 목록조회 (관리자)
 *
 * @param params
 * @returns {*}
 */
export const retrieveUsers = (params) => {
   return http.get(`/cms/user?${querystring.stringify(params)}`)
}

/**
 * 회원 상세조회 ( 관리자)
 *
 * @param user_id
 * @returns {*}
 */
export const findUser = (user_id) => {
    return http.get( `/cms/user/${user_id}` )
}


/**
 * 회원 정보수정 ( 관리자)
 *
 * @param user_id
 * @returns {*}
 */
export const modifyUser = (data,user_id) => {
    return http.put(`/cms/user/${user_id}`, data)
}

/**
 * 회원 정보삭제 ( 관리자)
 *
 * @param user_id
 * @returns {*}
 */
export const removeUser = (user_id) => {
    return http.remove(`/cms/user/${user_id}`)
}

/**
 * 본인 회원 정보 조회
 *
 * @param user_id
 * @returns {*}
 */
export const findUserMe = () => {
    return http.get(`/cms/me/`)
}

export const modifyUserMe = (data) => {

    return http.put(`/cms/me/`, data)
}


// /**
//  * 회원 정보 수정
//  *
//  * @param data
//  * @param user_id
//  * @returns {*}
//  */
// export const modifyUser = (data,user_id) => {
//     return http.put(`/cms/user/${user_id}`, data)
// }

